// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.enable-app-settings {
  padding: 2rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.enable-app-settings .enable-app-header {
  margin-bottom: 2rem;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 1rem;
}
.enable-app-settings .enable-app-header h4 {
  color: #8f003c;
  margin-bottom: 0.5rem;
  font-weight: 600;
}
.enable-app-settings .enable-app-header p {
  margin-bottom: 0;
  font-size: 0.9rem;
}
.enable-app-settings .enable-app-content .setting-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  border: 1px solid #dee2e6;
}
.enable-app-settings .enable-app-content .setting-item .setting-info {
  flex: 1 1;
}
.enable-app-settings .enable-app-content .setting-item .setting-info h5 {
  color: #495057;
  margin-bottom: 0.5rem;
  font-weight: 500;
}
.enable-app-settings .enable-app-content .setting-item .setting-info p {
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #6c757d;
}
.enable-app-settings .enable-app-content .setting-item .setting-control {
  margin-left: 2rem;
}
.enable-app-settings .enable-app-content .setting-item .setting-control .custom-switch .form-check-input {
  width: 3rem;
  height: 1.5rem;
  background-color: #6c757d;
  border-color: #6c757d;
}
.enable-app-settings .enable-app-content .setting-item .setting-control .custom-switch .form-check-input:checked {
  background-color: #8f003c;
  border-color: #8f003c;
}
.enable-app-settings .enable-app-content .setting-item .setting-control .custom-switch .form-check-input:focus {
  box-shadow: 0 0 0 0.25rem rgba(143, 0, 60, 0.25);
  border-color: #8f003c;
}
.enable-app-settings .enable-app-content .setting-item .setting-control .custom-switch .form-check-label {
  font-weight: 500;
  color: #495057;
  margin-left: 0.5rem;
}
.enable-app-settings .enable-app-content .setting-status {
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid #8f003c;
}
.enable-app-settings .enable-app-content .setting-status .status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
}
.enable-app-settings .enable-app-content .setting-status .status-badge.enabled {
  background-color: #d4edda;
  color: #155724;
}
.enable-app-settings .enable-app-content .setting-status .status-badge.disabled {
  background-color: #f8d7da;
  color: #721c24;
}
.enable-app-settings .setting-control .custom-switch .form-check-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
@media (max-width: 768px) {
  .enable-app-settings {
    padding: 1rem;
  }
  .enable-app-settings .enable-app-content .setting-item {
    flex-direction: column;
    align-items: flex-start;
  }
  .enable-app-settings .enable-app-content .setting-item .setting-control {
    margin-left: 0;
    margin-top: 1rem;
    align-self: stretch;
    text-align: right;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/views/members/enableAppSettings/enableAppSettings.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,wCAAA;AACF;AACE;EACE,mBAAA;EACA,gCAAA;EACA,oBAAA;AACJ;AACI;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;AACN;AAEI;EACE,gBAAA;EACA,iBAAA;AAAN;AAKI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;AAHN;AAKM;EACE,SAAA;AAHR;AAKQ;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;AAHV;AAMQ;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;AAJV;AAQM;EACE,iBAAA;AANR;AASU;EACE,WAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;AAPZ;AASY;EACE,yBAAA;EACA,qBAAA;AAPd;AAUY;EACE,gDAAA;EACA,qBAAA;AARd;AAYU;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AAVZ;AAgBI;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,8BAAA;AAdN;AAgBM;EACE,wBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAdR;AAgBQ;EACE,yBAAA;EACA,cAAA;AAdV;AAiBQ;EACE,yBAAA;EACA,cAAA;AAfV;AAsBE;EACE,YAAA;EACA,mBAAA;AApBJ;AAwBE;EAhHF;IAiHI,aAAA;EArBF;EAuBE;IACE,sBAAA;IACA,uBAAA;EArBJ;EAuBI;IACE,cAAA;IACA,gBAAA;IACA,mBAAA;IACA,iBAAA;EArBN;AACF","sourcesContent":[".enable-app-settings {\n  padding: 2rem;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n  .enable-app-header {\n    margin-bottom: 2rem;\n    border-bottom: 1px solid #e9ecef;\n    padding-bottom: 1rem;\n\n    h4 {\n      color: #8f003c;\n      margin-bottom: 0.5rem;\n      font-weight: 600;\n    }\n\n    p {\n      margin-bottom: 0;\n      font-size: 0.9rem;\n    }\n  }\n\n  .enable-app-content {\n    .setting-item {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 1.5rem;\n      background-color: #f8f9fa;\n      border-radius: 8px;\n      margin-bottom: 1.5rem;\n      border: 1px solid #dee2e6;\n\n      .setting-info {\n        flex: 1;\n\n        h5 {\n          color: #495057;\n          margin-bottom: 0.5rem;\n          font-weight: 500;\n        }\n\n        p {\n          margin-bottom: 0;\n          font-size: 0.875rem;\n          color: #6c757d;\n        }\n      }\n\n      .setting-control {\n        margin-left: 2rem;\n\n        .custom-switch {\n          .form-check-input {\n            width: 3rem;\n            height: 1.5rem;\n            background-color: #6c757d;\n            border-color: #6c757d;\n\n            &:checked {\n              background-color: #8f003c;\n              border-color: #8f003c;\n            }\n\n            &:focus {\n              box-shadow: 0 0 0 0.25rem rgba(143, 0, 60, 0.25);\n              border-color: #8f003c;\n            }\n          }\n\n          .form-check-label {\n            font-weight: 500;\n            color: #495057;\n            margin-left: 0.5rem;\n          }\n        }\n      }\n    }\n\n    .setting-status {\n      padding: 1rem;\n      background-color: #f8f9fa;\n      border-radius: 6px;\n      border-left: 4px solid #8f003c;\n\n      .status-badge {\n        padding: 0.25rem 0.75rem;\n        border-radius: 4px;\n        font-size: 0.875rem;\n        font-weight: 500;\n\n        &.enabled {\n          background-color: #d4edda;\n          color: #155724;\n        }\n\n        &.disabled {\n          background-color: #f8d7da;\n          color: #721c24;\n        }\n      }\n    }\n  }\n\n  // Loading state\n  .setting-control .custom-switch .form-check-input:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n\n  // Responsive design\n  @media (max-width: 768px) {\n    padding: 1rem;\n\n    .enable-app-content .setting-item {\n      flex-direction: column;\n      align-items: flex-start;\n\n      .setting-control {\n        margin-left: 0;\n        margin-top: 1rem;\n        align-self: stretch;\n        text-align: right;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
